import { render, staticRenderFns } from "./SystemInformationBin.vue?vue&type=template&id=ec2ee2d6&scoped=true&"
import script from "./SystemInformationBin.vue?vue&type=script&lang=ts&"
export * from "./SystemInformationBin.vue?vue&type=script&lang=ts&"
import style0 from "./SystemInformationBin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SystemInformationBin.vue?vue&type=style&index=1&id=ec2ee2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2ee2d6",
  null
  
)

component.options.__file = "SystemInformationBin.vue"
export default component.exports